
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-pull-quote{
  display:flex;
  background-color:var(--brand-primary-2);
  border-radius:0px 90px 90px;
  border-top-left-radius:0;
  padding:3rem 2rem;
  color:var(--brand-neutral-white);
}

  @media (min-width: 768px){.se-pull-quote{
    padding:3.25rem 4rem
}
  }

.se-pull-quote--quote{
  display:flex;
  letter-spacing:1px;
  flex-direction:column;
}

@media (min-width: 768px){

.se-pull-quote--quote{
    flex-direction:row
}
  }

slot[name='quote-text']::slotted(div){
  padding:1rem 0;
}

@media (min-width: 768px){

slot[name='quote-text']::slotted(div){
    padding:0 2rem;
    margin-block-start:1em;
    margin-block-end:1em
}
  }

.se-pull-quote--attribution{
  display:flex;
  text-transform:uppercase;
  justify-content:flex-end;
  font-weight:var(--fw-medium);
  font-family:var(--ff-dmsans);
  letter-spacing:1px;
}
`;